var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-button"},[_c('div',{staticClass:"estrutura",class:_vm.button_class},[_c('div',{staticClass:"button-type",attrs:{"type":"button"},on:{"click":_vm.select}},[_c('v-icon',{class:_vm.img,attrs:{"color":_vm.icon_class}})],1)]),_c('p',[_vm._v(_vm._s(_vm.mensagem))])])
}
var staticRenderFns = []

export { render, staticRenderFns }